export const ROUTE_CONFIG = {
  DASHBOARD: { path: 'dashboard', showDateFilter: true },
  PROVIDERS: { path: 'providers', showDateFilter: false },
  PROVIDERS_CREATE: { path: 'providers/create', showDateFilter: false },
  PROVIDERS_EDIT: { path: 'providers/edit/:id', showDateFilter: false },
  PROVIDERS_VIEW: { path: 'providers/:id', showDateFilter: false },
  OPERATORS: { path: 'operators', showDateFilter: false },
  VDI_TRANSACTIONS: { path: 'vditransactions', showDateFilter: true },
  QUIKPICK: { path: 'quikpick', showDateFilter: false },
  RECONCILIATION: { path: 'reconciliation', showDateFilter: true },
  PRODUCTS: { path: 'products', showDateFilter: true },
  USERS: { path: 'users', showDateFilter: false },
  USERS_VIEW: { path: 'users/:id', showDateFilter: false },
  MARKETS: { path: 'markets', showDateFilter: true },
  SMART_COOLER_ALERTS: { path: 'smartcoolers/alerts', showDateFilter: true },
  SMART_COOLER_PRODUCTS: { path: 'smartcoolers/products', showDateFilter: true },
  SMART_COOLER_TRANSACTIONS: { path: 'smartcoolers/transactions', showDateFilter: false },
  DEVICES: { path: 'devices', showDateFilter: true },
  SALES: { path: 'sales', showDateFilter: true },
  PROFILE: { path: 'profile', showDateFilter: false },
  CRONJOBS: { path: 'cronjobs', showDateFilter: true },
  TARGETED_RECONCILIATION: { path: 'targetedReconciliation', showDateFilter: false },
  SMART_COOLERS: { path: 'smartcoolers', showDateFilter: false },
  SMART_COOLERS_VIEW: { path: 'smartcoolers/:id', showDateFilter: false },
} as const;


export const DATE_FILTER_SUPPORTED_PAGE_PATHS = Object.values(ROUTE_CONFIG)
  .filter((route) => route.showDateFilter)
  .map((route) => `/${route.path}`);